import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useGangContext } from "./useGang.ts";

export function CheatModeDialog() {
  const { gang } = useGangContext();

  if (gang.mode.isCheatModeActive) {
    return (
      <ConfirmDialog
        heading="Disable cheat mode?"
        description="The gang will revert to following build mode or campaign constraints."
        submitLabel="Disable"
        onSubmit={() => {
          const mode = gang.mode.setCheatModeActive(false);
          return database.gangs.updateOne(mode.gang.data);
        }}
      />
    );
  }

  return (
    <ConfirmDialog
      heading="Enable cheat mode?"
      description="Cheat mode allows you to change your gang with minimal constraints."
      submitLabel="Enable"
      onSubmit={() => {
        const mode = gang.mode.setCheatModeActive(true);
        return database.gangs.updateOne(mode.gang.data);
      }}
    />
  );
}
